import { render, staticRenderFns } from "./scarfnewsagencyIndex.vue?vue&type=template&id=85ec7a58&scoped=true&"
import script from "./scarfnewsagencyIndex.vue?vue&type=script&lang=js&"
export * from "./scarfnewsagencyIndex.vue?vue&type=script&lang=js&"
import style0 from "./scarfnewsagencyIndex.vue?vue&type=style&index=0&id=85ec7a58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ec7a58",
  null
  
)

export default component.exports